import { translate } from 'react-i18nify';

export default function AnonymousModeNotice() {
  return (
    <div className="anonymous-mode-notice stack-1">
      <div
        dangerouslySetInnerHTML={{
          __html: translate('global.anonymous_mode_notice')
        }}
      />
      <div>
        <small>Avslöja en enskild dold text eller bild genom att klicka och hålla inne på den.</small>
      </div>
    </div>
  );
}
